import * as usersActions from '../redux/actions/usersActions';

// Persist session across tabs
// Parts adapted from https://blog.guya.net/security/browser_session/sessionStorage.html

function shareSessionBetweenTabs() {
  // First make sure we can handle all our storage events
  window.addEventListener('storage', (event) => {
    switch (event.key) {
      case 'getJwt':
        // Another tab asked for our token, let's send it
        if (sessionStorage.getItem('jwt')) {
          localStorage.setItem('jwt', sessionStorage.getItem('jwt'));
          // Kill it so that the event can fire again next time
          localStorage.setItem('jwt', '');
        }
        break;
      case 'jwt':
        // Another tab sent a token, let's take it if we need it
        if (!sessionStorage.getItem('jwt') && event.newValue) {
          sessionStorage.setItem('jwt', event.newValue);
        }
        break;
      default:
        // Let other miscellaneous events go
    }
  });

  if (!sessionStorage.getItem('jwt')) {
    // We're a new tab and need to check if other tabs have our token.
    localStorage.setItem('getJwt', Date.now());
  }
}

// Logout listener, separated since it needs to dispatch an action

export function listenForLogout(store) {
  window.addEventListener('storage', (event) => {
    if (event.key === 'logout') {
      // Another tab logged out, let's log ourselves out too
      store.dispatch(usersActions.logout());
    }
  });
}

export default shareSessionBetweenTabs;



// WEBPACK FOOTER //
// ./src/utils/sessionHandler.js